import { render, staticRenderFns } from "./DataplexRuleComponent.vue?vue&type=template&id=2016c205&lang=pug"
import script from "./DataplexRuleComponent.vue?vue&type=script&lang=js"
export * from "./DataplexRuleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2016c205')) {
      api.createRecord('2016c205', component.options)
    } else {
      api.reload('2016c205', component.options)
    }
    module.hot.accept("./DataplexRuleComponent.vue?vue&type=template&id=2016c205&lang=pug", function () {
      api.rerender('2016c205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/components/DataplexRuleComponent.vue"
export default component.exports